import { TOMCAT_URL } from 'src/common';

let csrfToken: string | undefined;

export async function getCsrfToken(): Promise<string> {
    if (!csrfToken) {
        const options: RequestInit = {
            credentials: 'include',
            cache: 'no-store',
        };

        try {
            const response = await fetch(`${TOMCAT_URL}public/csrf`, options);

            ({ token: csrfToken } = await response.json());
        } catch (error) {
            console.error('Failed to fetch csrf', error);
        }
    }

    return csrfToken || '';
}

export async function initializeCsrfToken() {
    csrfToken = await getCsrfToken();
}

export function getCsrfTokenSync(): string {
    if (!csrfToken) {
        throw new Error('CSRF token not initialized');
    }
    return csrfToken;
}
